import { render, staticRenderFns } from "./ClientReportView.vue?vue&type=template&id=ab73f6f2&scoped=true"
import script from "./ClientReportView.vue?vue&type=script&lang=js"
export * from "./ClientReportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab73f6f2",
  null
  
)

export default component.exports